/* Shared bridge for the three unpublished Mayhem integration drafts. */
(() => {
  'use strict';
  const bindings = new Map();
  let client = null;
  let appMode = false;
  let visualBinding = null, visualRequest = null;
  const visualKey = 'twg:mayhem:visualizer:v1';
  const visualIdentity = () => JSON.stringify(nativeVehicle?.query || null);
  const saveVisual = () => {
    if(visualBinding?.state!=='matched')return;
    try { window.localStorage?.setItem(visualKey,JSON.stringify({identity:visualIdentity(),vehicleId:visualBinding.vehicleId,expires:Date.now()+86400000})); } catch {}
  };
  const restoreVisual = () => {
    try {
      const saved=JSON.parse(window.localStorage?.getItem(visualKey)||'null');
      if(appMode && nativeVehicle && saved?.identity===visualIdentity() && Number.isFinite(saved.expires) && saved.expires>Date.now() && /^\d{1,12}$/.test(saved.vehicleId))
        visualBinding={state:'matched',vehicleId:saved.vehicleId,candidates:[]};
    } catch {}
  };
  const appRequests = new Map();
  let nativeVehicle = null;
  let nativeStore = null;
  let vehicleRestore = 'none';
  const restoreLegacySelection = async () => {
    if(nativeVehicle||!appMode)return;
    let saved;
    for(const name of ['localStorage','sessionStorage']){
      try{const value=JSON.parse(window[name]?.getItem('mayhem:selected-vehicle')||'null');
        if(value?.year&&value.make&&value.model&&value.submodel){saved=value;break;}
      }catch{}
    }
    if(!saved)return;
    const ticket=generation;
    vehicleRestore='loading';window.dispatchEvent(new CustomEvent('twg:vehicle-restore'));
    try{
      const query={year:String(saved.year),make:String(saved.make),model:String(saved.model)};
      const trims=await client.submodels(query,{signal:controller.signal});
      if(ticket!==generation||nativeVehicle)return;
      const equal=value=>String(value||'').trim().toLowerCase();
      const matches=trims.filter(trim=>equal(trim.name)===equal(saved.submodel));
      if(matches.length!==1)throw Error('Saved trim needs selection');
      const trim=matches[0];
      vehicleRestore='none';
      window.TWGFitmentPreview.selectVehicle({...query,provider:'twg_app',submodel:String(trim.id),trimName:trim.name},[query.year,query.make,query.model,trim.name].join(' · '));
    }catch{if(ticket===generation)vehicleRestore='needs_selection';}
    finally{if(ticket===generation||nativeVehicle)window.dispatchEvent(new CustomEvent('twg:vehicle-restore'));}
  };
  const skuRequests = new Map();
  const waiting = [];
  let running = 0;
  const pump = () => {
    while (running < 4 && waiting.length) {
      const job = waiting.shift(); running++;
      Promise.resolve().then(job.work).then(job.resolve,job.reject).finally(()=>{running--;pump();});
    }
  };
  const enqueue = work => new Promise((resolve,reject)=>{waiting.push({work,resolve,reject});pump();});
  const lookup = (query,signal) => {
    if(appMode){
      if(query.provider!=='twg_app')throw new Error('Select an app vehicle');
      const selection=Object.fromEntries(['year','make','model','submodel'].map(key=>[key,query[key]]));
      const key=JSON.stringify(selection),cached=appRequests.get(key);
      if(cached&&cached.expires>Date.now())return cached.promise;
      const promise=client.wheels(selection,{signal});
      const entry={promise,expires:Date.now()+900000};appRequests.set(key,entry);
      promise.catch(()=>{if(appRequests.get(key)===entry)appRequests.delete(key);});
      return promise;
    }
    if(query.provider==='twg_app')throw new Error('App provider is not enabled');
    const matches=[...bindings.values()].filter(binding=>['baseVehicleId','submodelId','bodyTypeId','driveTypeId','regionId','customNote']
      .every(key=>String(binding[key]??'')===String(query[key]??'')));
    return matches.length===1?client.fitment(query,{signal,vehicleBinding:matches[0]}):client.primaryFitment(query,{signal});
  };
  let generation = 0;
  let controller = new AbortController();
  const reset = () => { visualBinding=null;visualRequest=null; generation++; skuRequests.clear(); appRequests.clear(); controller.abort(); controller = new AbortController(); };
  const clearNative = () => {
    const hadNative = Boolean(nativeVehicle);
    vehicleRestore = 'none'; nativeVehicle = null; nativeStore?.clear(); reset();
    try { window.localStorage?.removeItem(visualKey); } catch {}
    if (hadNative) window.dispatchEvent(new CustomEvent('twg:vehicle-changed'));
  };
  const legacyChanged = event => {
    const id=event?.detail?.id ?? event?.detail?.vehicle?.Id;
    if(appMode)return;
    clearNative();
  };
  window.addEventListener('mayhem:vehicle-changed', legacyChanged);
  window.addEventListener('storage', event => {
    if (nativeStore && event.key === nativeStore.key) {
      nativeVehicle = nativeStore.read(); reset(); restoreVisual();
      window.dispatchEvent(new CustomEvent('twg:vehicle-changed'));
      return;
    }
    if(event.key===visualKey){visualBinding=null;restoreVisual();return;}
    if (!event.key) {clearNative();return;}
    if(event.key==='mayhem:selected-vehicle-id')legacyChanged({detail:{id:event.newValue}});
    if(event.key==='mayhem:selected-vehicle'){
      let saved;try{saved=JSON.parse(event.newValue);}catch{}
      legacyChanged({detail:{id:saved?.Id ?? saved?.id}});
    }
  });
  window.TWGFitmentPreview = Object.freeze({
    status() { return { enabled: Boolean(client), mappedVehicles: bindings.size, mode: appMode?'twg_app_draft':'isolated_draft', vehicleRestore }; },
    visualizerVehicleId() { return visualBinding?.state==='matched'?visualBinding.vehicleId:null; },
    async resolveVisualizerVehicle() {
      if(!appMode||!nativeVehicle)return {state:'unmapped',candidates:[]};
      if(visualBinding?.state==='matched')return visualBinding;
      if(visualRequest)return visualRequest;
      const ticket=generation,query={...nativeVehicle.query};
      visualRequest=window.TWGFitmentModules.createVisualizerResolver()(query,{signal:controller.signal}).then(result=>{
        if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
        visualBinding=result;saveVisual();window.dispatchEvent(new CustomEvent('twg:visualizer-ready'));return result;
      }).catch(error=>{if(ticket===generation)visualRequest=null;throw error;});
      return visualRequest;
    },
    selectVisualizerBody(id) {
      if(!visualBinding?.candidates?.some(row=>row.id===String(id)))throw new Error('Choose a listed visualizer vehicle');
      const choice=visualBinding.candidates.find(row=>row.id===String(id));
      nativeVehicle=window.TWGFitmentModules.cleanVehicle({...nativeVehicle.query,visualizerVehicleId:String(id),visualizerBody:choice.body,visualizerBed:choice.bed},
        [nativeVehicle.query.year,nativeVehicle.query.make,nativeVehicle.query.model,nativeVehicle.query.trimName,choice.body,choice.bed].filter(Boolean).join(' · '));
      nativeStore?.save(nativeVehicle);
      visualBinding={...visualBinding,state:'matched',vehicleId:String(id)};saveVisual();
      window.dispatchEvent(new CustomEvent('twg:visualizer-ready'));
    },
    selectedVehicle() { return client && nativeVehicle ? {...nativeVehicle,query:{...nativeVehicle.query}} : null; },
    selectVehicle(query, label, options = {}) {
      if (!client) throw new Error('Integration not enabled');
      vehicleRestore = 'none';
      nativeVehicle = window.TWGFitmentModules.cleanVehicle(query,label);
      nativeStore?.save(nativeVehicle);
      reset();restoreVisual();
      if (options.analyticsSource) window.dispatchEvent(new CustomEvent('mayhem:vehicle-selected', {detail:{vehicle:nativeVehicle,source:options.analyticsSource}}));
      window.dispatchEvent(new CustomEvent('twg:vehicle-changed'));
    },
    clearVehicle() {
      if(appMode)for(const name of ['localStorage','sessionStorage'])try{
        window[name]?.removeItem('mayhem:selected-vehicle');
        window[name]?.removeItem('mayhem:selected-vehicle-id');
      }catch{}
      clearNative();
    },
    async evaluateVehicle(vehicle, sku) {
      if (!client) throw new Error('Integration not enabled');
      const clean = window.TWGFitmentModules.cleanVehicle(vehicle.query,vehicle.label);
      const ticket = generation, signal=controller.signal;
      return enqueue(async()=>{
        if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
        const response=await lookup({...clean.query,sku},signal);
        if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
        return window.TWGFitmentModules.storefrontResult(response,sku);
      });
    },
    async evaluateSku(sku) {
      if (!client || !nativeVehicle) throw new Error('Select a complete vehicle');
      const ticket = generation;
      if (typeof sku !== 'string' || !sku.trim()) throw new Error('Exact SKU required');
      if(appMode){
        if(!skuRequests.has(sku)){
          const promise=lookup({...nativeVehicle.query,sku},controller.signal).then(response=>{
            if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
            return window.TWGFitmentModules.storefrontResult(response,sku);
          });
          skuRequests.set(sku,promise);
          promise.catch(()=>{if(skuRequests.get(sku)===promise)skuRequests.delete(sku);});
        }
        return skuRequests.get(sku);
      }
      if (!skuRequests.has(sku)) {
        const query = {...nativeVehicle.query,sku}, signal=controller.signal;
        const promise = enqueue(async()=>{
          if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
          const response = await lookup(query,signal);
          if(ticket!==generation)throw new DOMException('Vehicle changed','AbortError');
          return window.TWGFitmentModules.storefrontResult(response,sku);
        });
        skuRequests.set(sku,promise);
        promise.catch(()=>{if(skuRequests.get(sku)===promise)skuRequests.delete(sku);});
      }
      return skuRequests.get(sku);
    },
    createVehicleSelector(onChange) {
      if (!client) throw new Error('Integration not enabled');
      if(appMode)return window.TWGFitmentModules.createTWGAppSession({client,onChange});
      const session = window.TWGFitmentModules.createVehicleSession({ client, onChange });
      return session;
    },
    display: response => window.TWGFitmentModules.fitmentDisplay(response),
    mountVehicleSelector(container, options = {}) {
      if (!client) throw new Error('Integration not enabled');
      if(appMode)return window.TWGFitmentModules.mountTWGAppSelector({container,client,
        onApply:(query,label)=>window.TWGFitmentPreview.selectVehicle({...query,provider:'twg_app'},label,{analyticsSource:window.MayhemAnalytics?.vehicleSource(container) || 'vehicle_picker'}),
        onClear:()=>window.TWGFitmentPreview.clearVehicle(),showResults:options.showResults!==false});
      return window.TWGFitmentModules.mountFitmentSelector({ container, client, sku: options.sku,
        onApply: (query,label) => window.TWGFitmentPreview.selectVehicle(query,label,{analyticsSource:window.MayhemAnalytics?.vehicleSource(container) || 'vehicle_picker'}),
        onClear: clearNative, showResults: options.showResults !== false });
    },
    configureApp() {
      reset();appMode=true;
      let choicesStorage;try{choicesStorage=window.sessionStorage;}catch{}
      client=window.TWGFitmentModules.createTWGAppClient({storage:choicesStorage});
      let storage;try{storage=window.localStorage;}catch{}
      nativeStore=window.TWGFitmentModules.createVehicleStore(storage,'shopify-twg-app');
      nativeVehicle=nativeStore.read();restoreVisual();
      window.dispatchEvent(new CustomEvent('twg:vehicle-changed'));
      return restoreLegacySelection();
    },
    configure({ baseUrl }) {
      if (typeof window.MayhemFitmentPolicy?.evaluate !== 'function') throw new Error('Current Mayhem evaluator unavailable');
      reset();appMode=false;
      client = window.TWGFitmentModules.createFitmentClient({ baseUrl, brand: 'mayhem',
        autosyncFallback: window.TWGFitmentModules.createAutosyncAdapter({
          evaluate: (...args) => window.MayhemFitmentPolicy.evaluate(...args) }) });
      let storage; try { storage = window.localStorage; } catch {}
      nativeStore = window.TWGFitmentModules.createVehicleStore(storage,new URL(baseUrl).origin);
      nativeVehicle = nativeStore.read();
      window.dispatchEvent(new CustomEvent('twg:vehicle-changed'));
    },
    registerVerifiedVehicle(binding) {
      for (const key of ['baseVehicleId','autosyncVehicleId','submodelId','bodyTypeId','driveTypeId','regionId']) {
        if (!/^\d{1,12}$/.test(String(binding[key] ?? ''))) throw new Error('Incomplete verified vehicle mapping');
      }
      if (binding.confirmed !== true || !binding.source) throw new Error('Mapping provenance required');
      const copy = Object.freeze({ ...binding });
      bindings.set(String(binding.autosyncVehicleId), copy);
      reset();
    },
    async fitment({ autosyncVehicleId, sku, selection }) {
      if (!client) return { state: 'integration_not_enabled', results: [] };
      const binding = bindings.get(String(autosyncVehicleId));
      if (!binding) return { state: 'vehicle_mapping_required', results: [] };
      const ticket = generation;
      const query = Object.fromEntries(['baseVehicleId','submodelId','bodyTypeId','driveTypeId','regionId','customNote']
        .filter(key => binding[key] !== undefined).map(key => [key, binding[key]]));
      query.sku = sku;
      const result = await client.fitment(query, { signal: controller.signal, vehicleBinding: binding, selection });
      if (ticket !== generation) throw new DOMException('Vehicle changed', 'AbortError');
      return result;
    }
  });
})();

